module.exports = __webpack_public_path__ + "static/media/test17_5.9b635a64.png";